import axios from 'axios'
import { CALL_API } from 'tr-components/redux/CallApiMiddlewareActionCreator'
import { fetchOptions } from '../../../config/endpoints'

const FETCH_POSITIONS = 'Forms_Module/positions/FETCH_POSITIONS'
const FETCH_POSITIONS_SUCCESS = 'Forms_Module/positions/FETCH_POSITIONS_SUCCESS'
const FETCH_POSITIONS_FAIL = 'Forms_Module/positions/FETCH_POSITIONS_FAIL'

const UPDATE_FILTER = 'positions/UPDATE_FILTER'

const RESET_STATE = 'positions/RESET_STATE'

const UPDATE_SELECTED = 'positions/UPDATE_SELECTED'

export const actions = {
  FETCH_POSITIONS,
  FETCH_POSITIONS_SUCCESS,
  FETCH_POSITIONS_FAIL,
  RESET_STATE,
  UPDATE_FILTER,
  UPDATE_SELECTED
}

export const initialState = {
  positions: [],
  filteredIds: [],
  selected: [],
  filter: { text: '' },
  loading: false
}

export function filterItems({ items, query }) {
  return items.filter((x) => x.name.toLowerCase().includes(query)).map((x) => `${x.id}`)
}

// moved this for to be more readable / testable
export function sortPositions(items) {
  return items
    .sort((a, b) => a.positionName.localeCompare(b.positionName))
    .map((x) => ({
      id: x.positionId,
      name: x.positionName
    }))
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_POSITIONS:
      return {
        ...state,
        loading: true
      }
    case FETCH_POSITIONS_SUCCESS:
      const {
        payload: { positions = [] }
      } = action

      // position id can either be a uuid or a number :( going to normalize to string here.
      const normalizedPositions = positions.map((p) => ({
        ...p,
        positionId: p.positionId.toString()
      }))

      return {
        ...state,
        filteredIds: normalizedPositions.map((x) => x.positionId),
        loading: false,
        positions: sortPositions(normalizedPositions)
      }
    case FETCH_POSITIONS_FAIL:
      return {
        ...state,
        error: action.error,
        loading: false
      }

    case UPDATE_FILTER:
      return {
        ...state,
        filter: {
          ...state.filter,
          text: action.payload.value
        },
        filteredIds: filterItems({
          items: state.positions.slice(),
          query: action.payload.value.toLowerCase()
        })
      }
    case UPDATE_SELECTED:
      return {
        ...state,
        selected: action.payload.ids
      }
    case RESET_STATE:
      return {
        ...initialState,
        positions: state.positions,
        filteredIds: state.positions.map((x) => x.id)
      }
    default:
      return state
  }
}

export default reducer

export function fetchPositions() {
  return {
    type: CALL_API,
    types: [FETCH_POSITIONS, FETCH_POSITIONS_SUCCESS, FETCH_POSITIONS_FAIL],
    callAPI: () => axios.get('/positions', fetchOptions('v1'))
  }
}

export function updateSelected(ids) {
  return {
    type: UPDATE_SELECTED,
    payload: { ids }
  }
}

export function updateFilter({ filter, value }) {
  return {
    type: UPDATE_FILTER,
    payload: { filter, value }
  }
}

export function resetState() {
  return { type: RESET_STATE }
}



// WEBPACK FOOTER //
// ./src/modules/Forms/reducers/positions.js